import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastTitle,
  ToastViewport
} from "./toast";
import { useToast } from "./use-toast";

import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/solid";

export function Toaster() {
  const { toasts } = useToast();

  const getIcon = (variant) => {
    switch (variant) {
      case "success":
        return <CheckCircleIcon className="h-5 w-5 text-green-600" />;
      case "error":
        return <XCircleIcon className="h-5 w-5 text-red-600" />;
      case "warning":
        return <ExclamationTriangleIcon className="h-5 w-5 text-yellow-600" />;
      case "info":
        return <InformationCircleIcon className="h-5 w-5 text-blue-600" />;
      default:
        return null;
    }
  };
  

  return (
    <>
      {toasts.map(({ id, title, description, action, ...props }) => (
        <Toast
        key={id}
        variant={props.variant}
        open={props.open}
        onOpenChange={props.onOpenChange}
        {...props}
      >
        <div className="grid grid-cols-[auto_1fr] gap-2 items-start">
          {getIcon(props.variant)}
          <div className="grid gap-1">
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription>{description}</ToastDescription>}
          </div>
        </div>
        {action}
        <ToastClose />
      </Toast>
      
      ))}
      <ToastViewport />
    </>
  );
}
